{
  "password": {
    "show": "Afficher le mot de passe",
    "hide": "Masquer le mot de passe",
    "rule": "Au moins 8 caractères. Une courte phrase est facile à retenir et difficile à deviner."
  },
  "promise": {
    "title": "Sachez exactement ce que vous avez, où il se trouve, et comment il y est arrivé.",
    "recorded": {
      "title": "Chaque mouvement est enregistré",
      "text": "Le stock ne change que par des opérations validées : chaque chiffre peut être expliqué."
    },
    "locations": {
      "title": "Tous vos emplacements au même endroit",
      "text": "Entrepôts, magasins et stock en transit, côte à côte."
    },
    "alerts": {
      "title": "Prévenu avant qu'il ne soit trop tard",
      "text": "Les alertes de stock bas, de rupture et de stock négatif arrivent aux bonnes personnes."
    }
  },
  "fields": {
    "username": "Nom d'utilisateur",
    "usernamePlaceholder": "ex. amira",
    "password": "Mot de passe",
    "identifier": "Nom d'utilisateur ou email",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Répétez le nouveau mot de passe",
    "currentPassword": "Mot de passe actuel"
  },
  "signIn": {
    "title": "Bon retour",
    "subtitle": "Connectez-vous pour gérer votre stock.",
    "sessionEnded": "Votre session s'est fermée après {{minutes}} minutes d'inactivité. Reconnectez-vous pour continuer.",
    "passwordReset": "Votre mot de passe a été changé. Connectez-vous avec le nouveau.",
    "forgot": "Mot de passe oublié ?",
    "submit": "Se connecter",
    "securityNote": "Pour votre sécurité, le compte est bloqué {{lockout}} minutes après {{attempts}} mots de passe erronés. Les sessions se ferment après {{idle}} minutes d'inactivité.",
    "noAccount": "Pas encore de compte ? Demandez à votre administrateur de vous en créer un.",
    "restored": "Les données ont été restaurées depuis une sauvegarde : reconnectez-vous."
  },
  "forgot": {
    "back": "Retour à la connexion",
    "title": "Mot de passe oublié ?",
    "subtitle": "Nous vous envoyons par email un lien pour en choisir un nouveau.",
    "hint": "L'email part vers l'adresse enregistrée sur votre compte. Pas d'email sur votre compte ? Demandez à votre administrateur de réinitialiser votre mot de passe.",
    "submit": "M'envoyer un lien",
    "sentTitle": "Consultez vos emails",
    "sentText": "Si un compte correspond, un lien est en route. Il ne fonctionne qu'une fois et expire au bout d'une heure."
  },
  "reset": {
    "title": "Choisissez un nouveau mot de passe",
    "subtitle": "Vous vous connecterez désormais avec celui-ci. Vos autres sessions seront fermées.",
    "invalidTitle": "Ce lien n'est pas valide ou a expiré.",
    "requestAgain": "Demander un nouveau lien",
    "submit": "Enregistrer mon nouveau mot de passe"
  },
  "change": {
    "done": "Votre mot de passe a été changé.",
    "submit": "Changer le mot de passe",
    "submitAndContinue": "Enregistrer et continuer",
    "requiredTitle": "Bienvenue, {{name}}",
    "requiredSubtitle": "Choisissez votre propre mot de passe avant de commencer.",
    "requiredNotice": "Vous vous êtes connecté avec un mot de passe temporaire. Remplacez-le par un mot de passe que vous seul connaissez."
  }
}
